import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Tooltip, TooltipOptions } from '../types/tooltip';
import { AppExtraLoadingService } from './app-extra-loading.service';

@Injectable({
  providedIn: 'root',
})
export class TooltipService {
  private appExtraLoadingService = inject(AppExtraLoadingService);
  public readonly onTooltipShow = new BehaviorSubject<Tooltip>(undefined);

  show(text: string, el: HTMLElement, options: TooltipOptions) {
    this.onTooltipShow.next({ text, el, ...options });
    this.appExtraLoadingService.load$.next('tooltips');
  }

  hide() {
    this.onTooltipShow.next(undefined);
  }
}
